module.exports = __webpack_public_path__ + "img/CarFinance247_Logo_Horizontal.897b1d61.svg";